import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import DatatableAndModal from './DatatableAndModal';

const MakeAmendmentRequestListing = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('amendment->>AmendmentRequestListing.TitleHeader')} />
      <DatatableAndModal />
    </>
  );
};

export default MakeAmendmentRequestListing;
